import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=24a0fb66"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24a0fb66')) {
      api.createRecord('24a0fb66', component.options)
    } else {
      api.reload('24a0fb66', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=24a0fb66", function () {
      api.rerender('24a0fb66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/inquiry/Index.vue"
export default component.exports